import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Formik } from "formik";
import Axios from "axios";
import {
  Alert,
  DataStatus,
  ActionButton,
  AlertAlreadyStockOpname,
} from "components";
import { ConvertItepApi } from "api";
import { TableSection, FormSection } from "../Section";
import {
  formInitialValues,
  formSubmitMapper,
  formValidationSchema,
} from "../Utils";

const TambahConvertItem = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();
  const [dataBahan, setDataBahan] = useState([]);
  const [dropdown, setDropdown] = useState({
    bahan: [],
    gudang: [],
  });
  const [fetchingStatus, setFetchingStatus] = useState({
    loading: false,
    success: true,
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });

  const mappingDataBahan = (data) =>
    data.map((val) => ({
      value: val?.id_item_buaso,
      label: val.nama_item,
      idKelompok: val.id_kelompok,
      namaKelompok: val.nama_kelompok,
      idJenis: val.id_jenis,
      namaJenis: val.nama_jenis,
      idSatuan: val.id_satuan_pakai,
      namaSatuan: val.satuan_pakai,
      kodeItem: val.kode_item,
    }));
  const mappingDatagGudang = (data) =>
    data.map((val) => ({
      value: val?.id_gudang,
      label: val.nama_gudang,
    }));

  const getInitialValues = () => {
    setFetchingStatus({ loading: true, success: false });

    Axios.all([ConvertItepApi.getBahan(), ConvertItepApi.dropdownGudang()])
      .then(
        Axios.spread((bahan, gudang) => {
          setDropdown({
            bahan: mappingDataBahan(bahan.data.data ?? []),
            gudang: mappingDatagGudang(gudang.data.data ?? []),
          });
          setFetchingStatus({
            loading: false,
            success: true,
          });
        })
      )
      .catch(() => {
        setAlertConfig({
          show: false,
          variant: "primary",
          text: "Data gagal dimuat!",
        });
        setFetchingStatus({
          loading: false,
          success: false,
        });
      });
  };

  const formSubmitHandler = (values) => {
    ConvertItepApi.create(formSubmitMapper(values))
      .then(() => {
        history.push("/inventory/transaksi/convert-item", {
          alert: {
            show: true,
            variant: "primary",
            text: "Data berhasil disimpan!",
          },
          do: location?.state?.do,
        });
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal disimpan!",
        });
      })
      .finally(() => {});
  };

  useEffect(() => {
    setNavbarTitle("Convert Item");
    getInitialValues();
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues({}, dataBahan)}
      validationSchema={formValidationSchema}
      onSubmit={formSubmitHandler}
    >
      {(formik) => (
        <>
          <Alert
            show={alertConfig.show}
            variant={alertConfig.variant}
            text={alertConfig.text}
            showCloseButton={true}
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          {fetchingStatus.loading ? (
            <DataStatus loading text="Memuat . . ." />
          ) : fetchingStatus.success ? (
            <form onSubmit={formik.handleSubmit}>
              <FormSection dropdown={dropdown} />
              <TableSection dropdown={dropdown?.bahan} />
              <AlertAlreadyStockOpname tanggal={formik?.values?.tglConvert} />
              <div className="d-flex justify-content-end">
                <ActionButton
                  type="submit"
                  disable={formik?.values?.detail >= 0 && true}
                  text="Simpan"
                  loading={formik.isSubmitting}
                />
              </div>
            </form>
          ) : (
            <DataStatus text="Data gagal dimuat" />
          )}
        </>
      )}
    </Formik>
  );
};

export default TambahConvertItem;
